var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.partner==='uzima_ug')?_c('DeliveriesUzimaUg',{attrs:{"customer":_vm.customer}}):(_vm.partner==='default')?_c('DeliveriesDefault',{attrs:{"customer":_vm.customer}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }